import './chameleon.less';

import * as Business  from '../business';
import * as User      from '../user';
import { useFlags }   from '../app/feature_flags';
import chmln          from '@chamaeleonidae/chmln';
import React          from 'react';
import useRouteParams from '../hooks/use_route_params';


// https://app.chameleon.io/setup/install
const chameleonToken   = 'SMrSCY2gVSRpWqMIoeInl51TksiwsHbOHgKFweBGyqr1ei-1O6CwH-DJXUDANiG6Lgk7Nd';
const chameleonOptions = { fastUrl: 'https://fast.chameleon.io/' };


export default function Chameleon() {
  const flags          = useFlags();
  const setupChameleon = !!flags.dapChameleon;

  if (setupChameleon)
    return <SetupChameleon/>;
  else
    return null;
}


function SetupChameleon() {
  const { businessID } = useRouteParams();
  const profile        = User.useProfile();
  const isSalesforce   = User.useIsSalesforce();
  const business       = Business.useBusiness(businessID);

  React.useEffect(function initializeChameleon() {
    // don't initialize chameleon if user is salesforce impersonation, or if
    // already initialized
    if (!isSalesforce && !window.chmln)
      chmln.init(chameleonToken, chameleonOptions);
  }, [ isSalesforce ]);

  React.useEffect(function identifyChameleon() {
    if (window.chmln && business && profile) {
      chmln.identify(profile.userID, {
        email:        profile.email,
        name:         profile.name,
        businessID:   business.id,
        businessName: business.name,
      });
    }

    // clear chameleon and re-identify anytime business or profile changes
    return clearChameleon;
  }, [ business, profile ]);

  return null;
}


function clearChameleon() {
  if (window.chmln?.clear)
    window.chmln.clear();
}
